import {i18n} from '@yourcoach/i18n';

import type {AlertButton} from './components/Alert/types';

export const ALERT_SHOW_EVENT = 'ALERT::SHOW';

export const ALERT_HIDE_EVENT = 'ALERT::HIDE';

export const getTryAgainAlertButtons = (
  fn: Required<AlertButton>['onClick'],
  scheme: Required<AlertButton>['scheme'] = 'secondary',
): AlertButton[] => [
  {
    label: i18n.t('shared:later'),
  },
  {
    label: i18n.t('shared:try_again'),
    onClick: fn,
    scheme,
  },
];
